import { render, staticRenderFns } from "./OrderLogDetail.vue?vue&type=template&id=5bc3c616&scoped=true&"
import script from "./OrderLogDetail.vue?vue&type=script&lang=js&"
export * from "./OrderLogDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc3c616",
  null
  
)

export default component.exports